import { createQueryKey } from 'src/utils/query/createQueryKey';

export const vaultQueryKeys = {
	externalVaultStats: () => createQueryKey('externalVaultStats'),
	vaultConfigs: () => createQueryKey('vaultConfigs'),
	vaultApyReturns: () => createQueryKey('vaultApyReturns'),
	vaultOnChainData: () => createQueryKey('vaultOnChainData'),
	vaultDepositorAccounts: (authority?: string) =>
		createQueryKey('vaultDepositorAccounts', authority),
	vaultDepositorHistories: (authority?: string) =>
		createQueryKey('vaultDepositorHistories', authority),
	vaultSnapshots: (vaultPubkey?: string) =>
		createQueryKey('vaultSnapshots', vaultPubkey),
};
